export default ($http) => ({
  getSchools () {
    return $http.get('schools?limit=' + Number.MAX_SAFE_INTEGER)
  },
  getGrades () {
    return $http.get('grades?limit=' + Number.MAX_SAFE_INTEGER)
  },
  createGrade (payload) {
    return $http.post('grades', { body: payload })
  },
  fetchEditors (body) {
    return $http.post('all-teachers-by-term', { body })
  },
  fetchSiteLabels () {
    return $http.get('site-labels')
  }
})
